import { createAction, props } from "@ngrx/store";

import { AchBoStatusState } from "../models/consumer-logs/ach-bo-status-state";
import { AchDocumentState } from "../models/consumer-logs/ach-document-state";
import { AchStatusState } from "../models/consumer-logs/ach-status-state";
import { FailState } from "../models/fail-state";

export class ConsumerTransactionActions {
	static readonly achBoStatus = {
		get: createAction("[ACH BO Status] Get"),
		getApi: createAction("[ACH BO Status] Api Get"),
		getSuccess: createAction("[ACH BO Status] Loaded", props<AchBoStatusState>()),
		getFail: createAction("[ACH BO Status] Get Failed", props<FailState>())
	};
	static readonly achDocs = {
		get: createAction("[ACH Documents] Get"),
		getApi: createAction("[ACH Documents] Api Get"),
		getSuccess: createAction("[ACH Documents] Loaded", props<AchDocumentState>()),
		getFail: createAction("[ACH Documents] Get Failed", props<FailState>())
	};
	static readonly achStatus = {
		get: createAction("[ACH Status] Get"),
		getApi: createAction("[ACH Status] Api Get"),
		getSuccess: createAction("[ACH Status] Loaded", props<AchStatusState>()),
		getFail: createAction("[ACH Status] Get Failed", props<FailState>())
	};
}
